<div #widget class="container" *ngIf="enabled">
  <ng-container *ngIf="muted; else volumeTemplate">
    <mat-icon class="mute-icon">&#xe04f;</mat-icon>
  </ng-container>
  <ng-template #volumeTemplate>
    <span class="volume-value">{{ volume }}</span>
  </ng-template>
</div>
